import { EntityActionFactory, EntityOp } from '@ngrx/data';

import { TipoAnalisisLaboratorio } from './tipos-analisis-laboratorio.model';

const entityActionFactory = new EntityActionFactory();

export const entityTipoAnalisisLaboratorioLoadRequest =
  entityActionFactory.create<TipoAnalisisLaboratorio>(
    'TipoAnalisisLaboratorio',
    EntityOp.QUERY_ALL
  );
